var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor appstore-update-review-status" },
    [
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Review ID")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "App Store Review ID",
              "show-attributes": true,
              "automation-mode": "",
            },
            model: {
              value: _vm.clone.reviewId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "reviewId", $$v)
              },
              expression: "clone.reviewId",
            },
          }),
          _vm._v(" "),
          _c("small", [_vm._v("Durumu güncellenecek yorumun ID'si")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("div", { staticClass: "title" }, [_vm._v("Durum")]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              model: {
                value: _vm.clone.status,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "status", $$v)
                },
                expression: "clone.status",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "new" } }, [
                _vm._v("Yeni"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "replied" } }, [
                _vm._v("Yanıtlandı"),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "resolved" } }, [
                _vm._v("Çözüldü"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("small", [_vm._v("Yorumun yeni durumu")]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }